/**
 * Retorno seguro ao opener do popup de conexão (Fase 13, P2).
 *
 * Duas regras, ambas fail-closed:
 *
 * 1. `targetOrigin` NUNCA é "*". Só a origem do referrer, e só se for https (ou localhost em
 *    desenvolvimento). Sem referrer confiável, não se posta nada — o OtimizApp ainda enxerga a
 *    conexão pela listagem/relink; um postMessage para qualquer origem, não.
 * 2. O payload entregue ao opener passa por lista branca. O servidor já não devolve token
 *    (`sanitizarResultadoSignup`), mas o browser não confia nisso: filtra de novo.
 *
 * Módulo CommonJS de propósito: é importado pela ConnectPage (webpack interopera) E pelo harness
 * do backend (`scripts/openerSeguroHarness.ts`), sem React e sem DOM.
 */
var CAMPOS_PUBLICOS = ["connectionId", "phoneNumber", "wabaId", "pageName", "pageId", "igAccountId"];

function resolverTargetOrigin(referrer) {
  if (!referrer) return null;
  var u;
  try { u = new URL(String(referrer)); } catch (e) { return null; }
  var localhost = u.hostname === "localhost" || u.hostname === "127.0.0.1";
  if (u.protocol !== "https:" && !localhost) return null;
  return u.origin;
}

function sanitizarUma(conexao) {
  var saida = {};
  if (!conexao || typeof conexao !== "object") return saida;
  for (var i = 0; i < CAMPOS_PUBLICOS.length; i += 1) {
    var k = CAMPOS_PUBLICOS[i];
    if (conexao[k] !== undefined && conexao[k] !== null) saida[k] = conexao[k];
  }
  return saida;
}

/**
 * Varias contas Meta marcadas: `conexoes` (cada uma pela MESMA lista branca) e `falhas`
 * (so nome e mensagem). O OtimizApp cria um card por conexao.
 */
function sanitizarConexaoParaOpener(conexao) {
  var saida = sanitizarUma(conexao);
  if (conexao && Array.isArray(conexao.conexoes)) {
    saida.conexoes = conexao.conexoes.map(sanitizarUma);
  }
  if (conexao && Array.isArray(conexao.falhas)) {
    saida.falhas = conexao.falhas.map(function (x) {
      return { nome: String((x && x.nome) || ""), erro: String((x && x.erro) || "") };
    });
  }
  return saida;
}

module.exports = { resolverTargetOrigin, sanitizarConexaoParaOpener, CAMPOS_PUBLICOS };
